<div class="panel">
    <!--Heading-->
    <div class="panel-heading row" style="width:100%;margin-left:0px;margin-right:0px;">
        <div class="panel-control  col-xs-2" style="margin-right:30px;">
            <div class="btn-group">
                <button type="button" class="btn btn-default" (click)="logout()">退出</button>
            </div>
        </div>
        <h3 class="col-xs-5 panel-title">学习系统</h3>
        <div class="col-xs-1" style="line-height: 50px;">
            <div class="btn-group">
                <a href="#mychatroom" class="btn btn-default">去聊天</a>
            </div>
        </div>
    </div>

    <form class="form-horizontal" role="form" style="margin-top: 20px;">
        <div class="form-group">
          <label for="newword" class="col-sm-2 control-label">新词</label>
          <div class="col-sm-3">
            <input type="hidden" id="col0100" value="WORD">
            <input type="text" class="form-control" id="col00" placeholder="请输入词语" value="">
            
          </div>
          <div class="col-sm-2">
            <select class="form-control col-xs-8" id="col01">
                <option *ngFor="let country of wordTypeList" value= {{country.code}}>
                   {{country.name}}
                </option>
          </select>
          </div>
          <div class="col-sm-1">
            <button type="submit" class="btn btn-default" (click)="submitOneRow(0)">提交</button>
          </div>
          <label class="col-sm-1 control-label"><div *ngIf="showWaiting" class="sp sp-circle"></div><div *ngIf="!showWaiting">{{resultMsg}}</div></label>
        </div>

        <div class="form-group">
          <label for="stepTitle" class="col-sm-2 control-label">步骤类型内容标题(如菜谱等)</label>
          <div class="col-sm-3">
            <input type="hidden" id="col1100" value="STEP">
            <input type="text" class="form-control" id="col10"  placeholder="请输入步骤标题">
          </div>
          <div class="col-sm-8" style="margin-top: 10px;margin-left:100px;">
            <textarea class="form-control col-xs-11" style="background-color: rgb(250, 237, 221);"
             name="stepContent"  placeholder="请输入步骤内容" id="col11" rows="10" cols="40"></textarea>
           </div>
          <div class="col-sm-1">
            <button type="submit" class="btn btn-default" (click)="submitOneRow(1)">提交</button>
          </div>
        </div>


        <div class="form-group">
          <label for="storyTitle" class="col-sm-2 control-label">故事名称</label>
          <div class="col-sm-3">
            <input type="hidden" id="col2100" value="STORY">
            <input type="text" class="form-control" id="col20" name="storyTitle"  style="background-color: rgb(250, 237, 221);"  placeholder="请输入故事名称">
          </div>
          <div class="col-sm-8" style="margin-top: 10px;margin-left:100px;">
            <textarea class="form-control col-xs-11" style="background-color: rgb(250, 237, 221);" name="storyContent"  placeholder="请输入故事内容" id="col21" rows="10" cols="40"></textarea>
           </div>
          <div class="col-sm-1" style="padding-top:10px;">
            <button type="submit" class="btn btn-default" (click)="submitOneRow(2)">提交</button>
          </div>
        </div>

        
        <div class="form-group">
          <label for="newword" class="col-sm-2 control-label">客服对话培训</label>
          <div class="col-sm-3">
            <input type="hidden" id="col3100" value="KEFU">
            <input type="text" class="form-control" id="col30" placeholder="客户说" value="">
          </div>
          <div class="col-sm-3">
            <input type="text" class="form-control" id="col31" placeholder="客服回答说" value="">
          </div>
          <div class="col-sm-2">
            <select class="form-control col-xs-8" id="col32">
              <option value="KF_A">电脑售后</option>
              <option value="KF_B">空调售后</option>
            </select>
          </div>
          <div class="col-sm-2">
            <select class="form-control col-xs-8" id="col33">
              <option value="RP_LB">对答书</option>
            </select>
          </div>
          <div class="col-sm-1">
            <button type="submit" class="btn btn-default" (click)="submitOneRow(3)">提交</button>
          </div>
        </div>

        <div class="form-group">
          <label for="newword" class="col-sm-2 control-label">客服对话培训2</label>
          <div class="col-sm-2">
            <input type="hidden" id="col4100" value="KEFU2">
            <select class="form-control col-xs-8" id="col40">
              <option value="KF_A">电脑售后</option>
              <option value="KF_B">空调售后</option>
            </select>
          </div>
          <div class="col-sm-8" style="margin-top: 10px;margin-left:100px;">
            <label>客户说的为一行， 客服回答为第二行，如此类推</label><br>
            <textarea class="form-control col-xs-11" style="background-color: rgb(250, 237, 221);" name="kufuContent"  placeholder="请对话内容(按行区分)" id="col41" rows="10" cols="30"></textarea>
          </div>
          <div class="col-sm-2">
            <select class="form-control col-xs-8" id="col42">
              <option value="RP_LB">对答书</option>
            </select>
          </div>
          <div class="col-sm-1">
            <button type="submit" class="btn btn-default" (click)="submitOneRow(4)">提交</button>
          </div>
        </div>

      </form>

    <!--Widget body-->
    <div id="demo-chat-body" class="collapse in" style="visibility: hidden;">
        <div class="nano has-scrollbar" style="height:380px">
            <div class="nano-content pad-all" tabindex="0" style="right: -17px;" id="content">
                <ul class="list-unstyled media-block" #content>



                </ul>
            </div>
            <div class="nano-pane">
                <div class="nano-slider" style="height: 141px; transform: translate(0px, 0px);"></div>
            </div>
        </div>

        <!--Widget footer-->
        <div class="panel-footer">
            <div class="row">
            </div>
        </div>
    </div>
</div>